var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"fs-overlay",class:{'fs-overlay--visible': _vm.show},on:{"click":_vm.hide}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }